import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_AI3S_DEMO_2 = {
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  title: `Before Danu even starts manual work, <span style="color: #BEE3FF;">Scan \nsilently operates in the background, \nconsistently auditing and assessing \npotential risks.</span> If there's sudden activity, \nAI3S promptly alerts Danu, ensuring he stays \ninformed and can take immediate action.`,
  subtitle: "Infosys AI3S DEMO",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage(308),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(306),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "RESPONSIBLE_AI/AI3S_d1_06.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "RESPONSIBLE_AI/AI3S_demo_2_computer.png",
          imageStyle: {
            position: "absolute",
            right: "65.54px",
            bottom: "68px",
          },
          effect: "animate-opacity",
        },
        {
          image: "RESPONSIBLE_AI/AI3S_demo_2_shield.png",
          imageStyle: {
            position: "absolute",
            right: "461.33px",
            bottom: "527.44px",
          },
        },
        {
          image: "RESPONSIBLE_AI/AI3S_demo_2_paper.png",
          imageStyle: {
            position: "absolute",
            right: "168.29px",
            bottom: "231.41px",
          },
        },
      ]}
      pageNumber={307}
    />
  ),
};
